<template>
 <v-container fluid ma-0 pa-0 px-4 id="bucketnew-main">
    <Loading :isLoading="loading">
     <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  New Bucket
                </h2>
              </template>
                <span>New Bucket</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Configure your new bucket</h4>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>
      <v-container pa-0 mt-4 fluid class="elevation-2 rounded-3" style="background-color:white">
        <v-flex>
          <v-tabs id="bucketnew-tabs" grow slider-color="primary">
            <template v-for="item in items">
              <v-tab ripple :key="item.component">{{ item.name }}</v-tab>
              <v-tab-item :key="item.name">
                <v-divider></v-divider>
                <v-container fluid>
                  <v-layout row wrap>
                    <v-flex
                      xs12 px-4 pt-3
                      pb-1 mb-0>
                      <component
                        :is="item.component"
                        v-on:bucket-update="changesMade=true"
                        :bucket="bucket"
                        :caseType="caseType"
                        :schema="currentSchema"/>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
            </template>
          </v-tabs>
        </v-flex>
      </v-container>

      <v-layout row fluid wrap>
        <v-spacer></v-spacer>
        <v-btn
          @click="backToBuckets()"
          class="mt-4 mb-0 mx-0 mr-2"
          color="error"
          id="bucketnew-back-btn"
          tyle="float:right">
          Cancel
        </v-btn>
        <v-btn
          @click="showSaveBucketDialog = true"
          class="mt-4 mb-0 mx-0"
          color="success"
          id="bucketnew-save-btn"
          tyle="float:right">
          Create new bucket
        </v-btn>

        <v-dialog
          id="bucketnew-save-dialog"
          max-width="400"
          persistent
          v-model="showSaveBucketDialog">
          <v-card class="pa-4">
            <v-card-title class="pa-0 pb-2">
              <h2>Ready to create your bucket</h2>
            </v-card-title>

            <v-card-text class="pa-0">
              You're about to create a new bucket.
            </v-card-text>

            <v-card-actions class="ma-0 pa-0 pt-3">
              <v-btn
                @click="createBucket()"
                color="success"
                id="bucketnew-save-dialog-save-btn">
                Yes, Create this bucket
              </v-btn>

              <v-btn
                @click="backToBuckets()"
                color="error"
                id="bucketnew-save-dialog-cancel-btn">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </Loading>
  </v-container>
</template>

<script>
import "@/assets/styles/styles.css"
import { mapState } from "vuex"
import BucketAdvancedTab from "@/components/buckets/bucket-edit/Tabs/BucketAdvancedTab.vue"
import BucketDetailsTab from "@/components/buckets/bucket-edit/Tabs/BucketDetailsTab.vue"
import BucketFieldsTab from "@/components/buckets/bucket-edit/Tabs/BucketFieldsTab.vue"
import BucketFiltersTab from "@/components/buckets/bucket-edit/Tabs/BucketFiltersTab.vue"
import Loading from "@/components/shared/Loading.vue"

export default {
  name: "bucket-new",
  components: { BucketAdvancedTab, BucketDetailsTab, BucketFieldsTab, BucketFiltersTab, Loading },
  data: () => ({
    data: { icon: "archive" },
    changesMade: false,
    loading: false,
    showSaveBucketDialog: false,
    showDeleteBucketDialog: "",
    items: [
      { name: "Details", title: "Details", component: "BucketDetailsTab" },
      { name: "Fields", title: "Displayed Fields", component: "BucketFieldsTab" },
      { name: "Filters", title: "Filters", component: "BucketFiltersTab" },
      { name: "Advanced", title: "Advanced", component: "BucketAdvancedTab" }
    ],
    selected: { name: "Details", title: "Details", component: "BucketDetailsTab" }
  }),
  watch: {
    selected() { this.checkSaveDialog() },
    currentUserLoading() { this.loadData() }
  },
  computed: {
    ...mapState({
      bucket: state => state.buckets.current.bucket,
      caseType: state => state.caseTypes.current,
      currentUser: state => state.currentUser,
      currentUserLoading: state => state.currentUser.isCurrentUserLoading,
      lastCaseContainerPath: state => state.ui.lastCaseContainerPath,
      currentBucketGroup: state => state.buckets.current.bucketGroup
    }),
    bucketGroups() {
      if (this.caseType && this.caseType.bucketGroups) {
        return this.caseType.bucketGroups
      } else {
        return []
      }
    },
    currentSchema() {
      const fieldsets = [{ name: "common", fields: [{ name: "title" }, { name: "current_state" }, { name: "created_at" }, { name: "updated_at" }, { name: "last_exported_at" }, { name: "last_exported_via_bucket_id" }, { name: "sentiment_score" }, { name: "sentiment_magnitude" }, { name: "no_unread_conversations" }] }]

      for (const fs of this.caseType.currentSchema.fieldsets) {
        fieldsets.push(
          { name: fs.name, fields: fs.fields.map(f => ({ name: f.name })) }
        )
      }
      return { fieldsets }
    }
  },
  async mounted() {
    return await this.$store.dispatch('clearBucket')
  },
  methods: {
    async loadData() {
      await this.$store.dispatch('setSchema', this.$route.params.case_type_id)
    },
    checkSaveDialog() {
      this.showSaveBucketDialog = this.changesMade
    },
    async createBucket() {
      this.changesMade = false
      this.showSaveBucketDialog = false
      this.bucket.caseTypeId = parseInt(this.caseType.id)
      const newBucket = await this.$store.dispatch("createBucket", this.bucket)
      if (newBucket && this.lastCaseContainerPath && this.lastCaseContainerPath.length > 0) {
        const lastPath = this.lastCaseContainerPath[this.lastCaseContainerPath.length - 1].path
        const pathParts = lastPath.split("/")
        if (pathParts[3] === "bucket-groups") {
          if (pathParts[4] === "new") {
            this.currentBucketGroup.buckets.push({ id: newBucket.id, name: this.bucket.name })
            this.$store.dispatch("setHasChanged", true)
          } else {
            const bucketGroupId = parseInt(pathParts[4])
            if (bucketGroupId) {
              if (this.bucketGroups.length > 0) {
                const bucketGroup = this.bucketGroups.find((bg) => bg.id === bucketGroupId)
                if (bucketGroup) {
                  bucketGroup.buckets.push({ id: newBucket.id, name: this.bucket.name })
                  this.$store.dispatch("setHasChanged", true)
                }
              }
            }
          }
        }
      }
      await this.backToBuckets()
    },
    cancelCreate() {
      this.changesMade = false
      this.showSaveBucketDialog = false
    },
    async backToBuckets() {
      this.changesMade = false
      this.showSaveBucketDialog = false
      await this.$store.dispatch('clearBucket')
      this.$router.back()
    }
  }
}
</script>
